import CapacitorInstall from "../../../../contents/docs/integrate/_snippets/install-capacitor.mdx";
import CapacitorSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-capacitor.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import * as React from 'react';
export default {
  CapacitorInstall,
  CapacitorSendEvents,
  FeatureFlagsLibsIntro,
  React
};